import axios from "../util/axios";
import commonApi from "@/api/commonApi";

/**
 * util主要做缓存数据存取
 */
export default {
    checkTabsNumber: null,
    setTabsCheck(func) {
      this.checkTabsNumber = func;
    },
    // 缓存整个页面的数据
    cachePageData(page, to, from) {
        console.log("缓存页面数据")
        // 缓存数据前，如果有tabCheck，检查数量
        if (this.checkTabsNumber) {
            this.checkTabsNumber(to, from);
        }
        if (!page) {
            return;
        }
        // 获取整个data数据，缓存起来
        let data = {query: JSON.stringify(page.route?page.route.query:{}), data: page.$data};
        this.setSession(page.route?page.route.path:window.location.pathname, JSON.stringify(data));
    },
    // 打开页面时，如果有缓存就加载缓存数据,返回true/false
    loadPageData(page) {
        console.log("加载缓存数据")
        // 是否有缓存
        let data = this.getSession(page.route.path);
        if (data) {
            data = JSON.parse(data);
            if (data.query === JSON.stringify(page.route.query)) {
                // 参数是相同的，加载
                for (let k in data.data) {
                    page.$data[k] = data.data[k];
                }
                return true;
            }
        }
        return false;
    },
    removeTab(url) {
      this.removeSession(url)
    },
    // 把list转成tree
    list2Tree(list, idName, parentIdName) {
        let arr = [];
        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (!item[parentIdName]) {
                arr.push(item);
            }
            for (let j = 0; j < list.length; j++) {
                if (item[idName] === list[j][parentIdName]) {
                    if (!item.children) {
                        item.children = [];
                    }
                    item.children.push(list[j]);
                }
            }
        }
        return arr;
    },
    /**
     * 从其它页面跳转到列表页面，获取上次保存的查询条件
     */
    listGetParams() {
        let data = sessionStorage.getItem(window.location.pathname);
        if (data) {
            return JSON.parse(data);
        } else {
            return {};
        }
    },
    /**
     * 清空缓存的参数
     * @param path
     */
    clearListParam(path) {
        sessionStorage.removeItem(path);
    },
    /**
     * 从列表页面跳转到详情页面，在session中保存当前查询条件
     * @param params
     */
    beforeList2Detail(params) {
        sessionStorage.setItem(window.location.pathname, JSON.stringify(params));
    },
    /**
     * 当table列表有selection时，选择某一行，让这条数据被选中, 这个事件对应table的clickRow
     * @param column 判断的字段名
     * @param rowData 点击哪一行
     * @param selectionData selection的数据
     * @param tableData 列表的数据
     * @param ref table的ref
     */
    tableSelectionRowClick(column, rowData, selectionData, tableData, ref) {
        // 这条数据当前是被选中还是没有被选中
        let selected = false;
        for (let i = 0; i < selectionData.length; i++) {
            if (rowData[column] === selectionData[i][column]) {
                selected = true;
                break;
            }
        }
        // 被选中
        for (let i = 0; i < tableData.length; i++) {
            if (rowData[column] === tableData[i][column]) {
                ref.toggleRowSelection(tableData[i], !selected);
                break;
            }
        }
    },

    // 获取当前的运行环境,1web端，2企业微信PC端，3企业微信手机端, 4 pda,5微信小程序PC端，6 微信小程序手机端
    getContextPath() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = /phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone/i.test(userAgent);
        const isWeChat = /micromessenger/i.test(userAgent);
        const isWorkWeChat = /wxwork/i.test(userAgent);

        if (isWorkWeChat) { // 企业微信
            // 测试用，如果分辨率小于1024，则认为是手机端，否则是PC端
            const isMobile = window.innerWidth < 1024;
            return isMobile ? 3 : 2;
        } else if (isWeChat) { // 个人微信
            return isMobile ? 6 : 5;
        } else {
            return 1;
        }
    },
    // 是否已购买企业微信账号，是否开通外部联系人
    getQywxAccountType() {
        return new Promise(resolve => {
            this.getUserInfo().then(user => resolve(user.qywxAccountType));
        })
    },
    // 获取行政区划字典,这个需要同步获取
    async getAdministrativeArea() {
      let cached = this.getSession("administrativeArea");
      if (!cached) {
          // 没有数据，获取数据并缓存
          const data = await axios.get({url: "/basedata/common/queryAdministrativeArea"});
          // 缓存数据
          this.setSession("administrativeArea", JSON.stringify(data));
          return data;
      } else {
          return JSON.parse(cached);
      }
    },
    // 获取系统配置项，并转成下拉框选项
    getSystemSettingOptions(settingCode) {
        return new Promise(resolve => {
           commonApi.findSetting(settingCode).then(setting => {
               if (!setting || !setting.settingValue) {
                   return resolve([]);
               }
               let settingValue = JSON.parse(setting.settingValue);
               let settingParams = JSON.parse(setting.settingParams);
               let arr = [];
               for (let i = 0; i < settingValue.length; i++) {
                   for (let j = 0; j < settingParams.length; j++) {
                       if (settingValue[i] === settingParams[j].code) {
                           arr.push({name: settingParams[j].name, code: parseInt(settingParams[j].code)});
                           break;
                       }
                   }
               }
               return resolve(arr);
           })
        });
    },
    // 获取系统配置项，这个需要同步获取
    async getSystemSetting() {
        return new Promise(resolve => {
            let cached = this.getSession("systemSetting");
            if (!cached) {
                // 没有数据，获取数据并缓存
                axios.get({url: "/basedata/common/getSetting"}).then(data => {
                    // 把获取到的data转成对象
                    let result = {};
                    if (data.length > 0) {
                        data.forEach(d => result[d.settingCode] = d.settingValue)
                    }
                    // 缓存数据
                    this.setSession("systemSetting", JSON.stringify(result));
                    resolve(result);
                });
            } else {
                resolve(JSON.parse(cached)) ;
            }
        })
    },
    // 获取全部的职员列表
    async getAllEmployess() {
        let cached = this.getSession("employees");
        if (!cached) {
            // 没有数据，获取数据并缓存
            const data = await axios.get({url: "/basedata/common/queryEmployeeList"});
            // 缓存数据
            this.setSession("employees", JSON.stringify(data));
            return data;
        } else {
            return JSON.parse(cached);
        }
    },
    // 获取全部的角色列表
    async getAllRoles() {
        let cached = this.getSession("roles");
        if (!cached) {
            // 没有数据，获取数据并缓存
            const data = await axios.get({url: "/basedata/common/queryAllRoles"});
            // 缓存数据
            this.setSession("roles", JSON.stringify(data));
            return data;
        } else {
            return JSON.parse(cached);
        }
    },
    // 请求去重,某些请求需要去重，避免客户双击引起数据重复
    async distinct(url, timeout = 3000) {
        return new Promise((resolve, reject) => {
            let name = "distinctUrl";
            // 缓存的数据
            let ses = sessionStorage.getItem(name);
            if (!ses) {
                // 数据不存在，添加数据，执行函数
                sessionStorage.setItem(name, url + ";" + new Date().getTime());
                resolve();
            } else {
                // 数据存在，看是否过了时间
                let data = ses.split(";");
                if (url === data[0]) {
                    // 是url，看时间
                    if (new Date().getTime() - data[1] > timeout) {
                        // 缓存的不是这个url，执行
                        sessionStorage.setItem(name, url + ";" + new Date().getTime());
                        resolve();
                    } else {
                        reject();
                    }
                } else {
                    // 缓存的不是这个url，执行
                    sessionStorage.setItem(name, url + ";" + new Date().getTime());
                    resolve();
                }
            }
        });
    },
    // 获取token
    getHeaderToken() {
        let token = this.findSessionHeader();
        if (!token) {
            token = this.findCookieHeader();
        }
        return token.token;
    },
    // 获取HTTP请求头
    findSessionHeader() {
        if (this.getSession("grantedToken")) {
            let grantedToken = this.getSession("grantedToken")
            return {grantedToken}
        } else if (this.getSession("account")) {
            let token = JSON.parse(this.getSession("account")).token;
            if (token) return {token}
        }
        return false
    },
    findCookieHeader() {
        let token = this.getCookie("token")
        if (token) return {token}
        return false
    },
    // 清空session
    clearCacheData() {
        // 清空indexdb，这个已经没有用了
        sessionStorage.removeItem("indexedDb");
        // 清空列配置数据的显示缓存
        sessionStorage.removeItem("userColumnSetting");
        // 清空行政区划数据
        sessionStorage.removeItem("administrative");
        // 清空菜单列表
        sessionStorage.removeItem("menuList");
    },
    clearSession() {
        // 清理session,会退出登录
        sessionStorage.clear();
    },
    setUserInfo(userInfo) {
        sessionStorage.setItem("account", JSON.stringify(userInfo));
    },
    /**
     * 保存自动登录凭据（登录页手动登录成功后调用）
     *
     * 只保存到当天：autoLoginCredential 里带 date(yyyy-MM-dd)，
     * 读取时日期不是今天就视为过期并删除。
     */
    setAutoLoginCredential(account, password) {
        if (!account || !password) {
            return;
        }
        try {
            const d = new Date();
            const date = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0")
                + "-" + String(d.getDate()).padStart(2, "0");
            localStorage.setItem("autoLoginCredential", JSON.stringify({account, password, date}));
        } catch (e) {
            // 隐私模式/存储被禁用时静默失败，不影响正常登录
        }
    },
    /** 读取当天的自动登录凭据，过期或不存在返回 null */
    getAutoLoginCredential() {
        try {
            const raw = localStorage.getItem("autoLoginCredential");
            if (!raw) {
                return null;
            }
            const data = JSON.parse(raw);
            const d = new Date();
            const today = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0")
                + "-" + String(d.getDate()).padStart(2, "0");
            if (!data || !data.account || !data.password || data.date !== today) {
                this.clearAutoLoginCredential();
                return null;
            }
            return data;
        } catch (e) {
            this.clearAutoLoginCredential();
            return null;
        }
    },
    clearAutoLoginCredential() {
        try {
            localStorage.removeItem("autoLoginCredential");
        } catch (e) {
            // ignore
        }
    },
    /**
     * 企业微信消息进来的商户id。
     *
     * 消息里的地址带 merchantId，代理页在跳业务页之前写进来。
     * 业务页发现未登录（3000）时靠它知道要用哪个商户的企业微信凭据发起授权 ——
     * 那时用户还没有登录态，拿不到任何商户信息。
     *
     * ★ 必须在 util.clearSession() 之前读：那个方法是 sessionStorage.clear()，
     * 会把这里写的值一起清掉。axios 里的调用顺序已经按这个前提排好。
     */
    setQywxMerchantId(merchantId) {
        sessionStorage.setItem("qywxMerchantId", merchantId);
    },
    getQywxMerchantId() {
        return this.getSession("qywxMerchantId");
    },
    /**
     * 被登录拦下之前的页面地址（path + query）。
     *
     * 走企业微信授权会离开当前页，登录完要回到原来那一页，
     * 而不是把用户丢回工作台 —— 他本来就是从消息里点进某个单据的。
     * 登录页用完即清，避免下次登录又跳回一个早就过期的页面。
     */
    setQywxBackUrl(url) {
        sessionStorage.setItem("qywxBackUrl", url);
    },
    getQywxBackUrl() {
        return this.getSession("qywxBackUrl");
    },
    clearQywxBackUrl() {
        sessionStorage.removeItem("qywxBackUrl");
    },
    // 在session中存放、获取、删除缓存数据
    setSession(name, val) {
        sessionStorage.setItem(name, val)
    },
    /**
     * 同步获取 session 中的登录用户对象，不向后台请求
     *
     * 登录成功时 Login.vue 会调 setUserInfo 把 UserDto 落进 session，所以这里取得到。
     * 取不到（未登录 / 还没落 session）返回 null。
     *
     * @returns {object|null}
     */
    getLoginUser() {
        let str = this.getSession("account");
        if (!str) {
            return null;
        }
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    },
    /**
     * 获取角色分类，1超级管理员 2普通角色
     *
     * 同步读取，页面用它控制查询条件的显隐时，用异步的 getUserInfo
     * 会让超级管理员在首屏先闪一下「普通角色」的样子。
     *
     * @returns {number|string} 取不到时返回 ""（未登录或登录信息还没落 session）
     */
    getRoleType() {
        const user = this.getLoginUser();
        return user ? user.roleType : "";
    },
    /**
     * 获取当前登录职员的id（ba_employee.id）
     *
     * 新建客户 / 供应商 / 商机时用它预填负责人 —— 谁建的默认就是谁负责。
     * 同步读取，避免异步回来时用户已经动过表单被覆盖。
     *
     * @returns {string} 取不到时返回 ""
     */
    getEmployeeId() {
        const user = this.getLoginUser();
        return user && user.id ? user.id : "";
    },
    /**
     * 获取登录用户信息
     * @param force 是否强制获取，强制获取会向后台请求，否则只从session获取
     * @returns {Promise<unknown>}
     */
    async getUserInfo(force = true) {
        return new Promise((resolve) => {
            let str = this.getSession("account");
            if (!force) {
                resolve(null);
                return;
            }
            // session中没有登录信息
            if (str) {
                resolve(JSON.parse(str));
                return;
            }
            commonApi.getUserInfo().then(user => {
                this.setSession("account", JSON.stringify(user));
                resolve(user);
            })
        })
    },
    getSession(name) {
        if (sessionStorage.getItem(name)) return sessionStorage.getItem(name)
        return "";
    },
    // 清除某个session
    removeSession(name) {
      sessionStorage.removeItem(name);
    },
    // 获取对应权限
    async getAccess(path, access) {
        try {
            const res = await this.getUserInfo();
            for (let i = 0; i < res.accessModules.length; i++) {
                if (res.accessModules[i].url === path) {
                    switch (access) {
                        case "read":
                            return res.accessModules[i].accessModel.charAt(0);
                    }
                }
            }
            return ""; // 如果没有匹配的访问权限，则返回空字符串
        } catch (error) {
            console.error('获取用户信息时发生错误:', error); // 错误处理
        }
    },
    delSession(name) {
        sessionStorage.removeItem(name);
    },
    /**
     *
     * @param name
     * @param value
     * @param exdays 缓存多少天
     */
    setCookie(name, value, exdays) {
        if (exdays) {
            let exp = new Date(); //设置Cookie过期日期
            exp.setTime(exdays * 24 * 60 * 60 * 1000 + exp.getTime());
            //添加Cookie
            document.cookie = name + "=" + value + ";expires=" + exp.toGMTString();
        } else {
            document.cookie = name + "=" + value + ";";
        }
    },
    getCookie(name) {
        // name = config.systemCode + name;
        let cname = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(cname) != -1) return c.substring(cname.length, c.length);
        }
        return "";
    },
    clearCookie(name) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let cval = this.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },

    setEditType(arr, children) {
        arr.map(i => {
            i.editType = true;
            if (i[children]) i[children] = this.setEditType(i[children], children)
        })
        return arr
    },
    // 获取图片地址，如果是多张图片，返回数组，如果是单张，返回字符串
    getImageUrl(url) {
        if (url.startsWith("[")) {
            let arr = JSON.parse(url);
            let res = [];
            for (let i = 0; i < arr.length; i++) {
                res.push(this.getImageUrlSingle(arr[i]));
            }
            return res;
        } else if (url.startsWith("{")) {
            let obj = JSON.parse(url);
            return this.getImageUrlSingle(obj.url);
        } else {
            return this.getImageUrlSingle(url);
        }
    },
    getImageUrlSingle(url) {
        if (typeof url === "object") {
            return this.getImageUrlSingle(url.url);
        }
        if (url.startsWith("http")) {
            return url;
        } else if (url.startsWith("data:")) {
            return url;
        } else {
            // 需要拼接
            let base = process.env.VUE_APP_FILE_URL;
            return base + url;
        }
    }
}